import { ConfiguratorMessageConfig } from './configurator-message.config';

export const defaultConfiguratorMessageConfig: ConfiguratorMessageConfig = {
  productConfigurator: {
    updateConfigurationMessage: {
      waitingTime: 1000,
    },
  },
};
